<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">Editar Documento</h2>

  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="volver()"
    >
      Volver
    </button>
  </div>
  <form
    [formGroup]="documentoForm"
    (ngSubmit)="actualizarDocumento()"
    class="space-y-6"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Nombre -->
      <div class="form-group">
        <label for="nombre" class="block text-lg font-medium">Nombre</label>
        <input
          id="nombre"
          type="text"
          formControlName="nombre"
          class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ingrese el nombre del documento"
        />
        <div
          *ngIf="
            documentoForm.get('nombre')?.invalid &&
            documentoForm.get('nombre')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          El nombre es obligatorio y no debe exceder los 100 caracteres.
        </div>
      </div>

      <!-- Descripción -->
      <div class="form-group">
        <label for="descripcion" class="block text-lg font-medium"
          >Descripción</label
        >
        <textarea
          id="descripcion"
          formControlName="descripcion"
          class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ingrese una descripción"
          rows="4"
        ></textarea>
        <div
          *ngIf="
            documentoForm.get('descripcion')?.invalid &&
            documentoForm.get('descripcion')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          La descripción es obligatoria.
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Tipo de Documento -->
      <div class="form-group">
        <label for="tipo_documento" class="block text-lg font-medium"
          >Tipo de Documento</label
        >
        <select
          id="tipo_documento"
          formControlName="tipo_documento"
          class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="" disabled>Seleccione un tipo</option>
          <option value="PDF">PDF</option>
          <option value="WORD">WORD</option>
          <option value="EXCEL">EXCEL</option>
        </select>
        <div
          *ngIf="
            documentoForm.get('tipo_documento')?.invalid &&
            documentoForm.get('tipo_documento')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          El tipo de documento es obligatorio.
        </div>
      </div>
      <!-- Link Formato -->
      <div class="form-group">
        <label for="link_formato" class="block text-lg font-medium"
          >Link Formato</label
        >
        <input
          id="link_formato"
          type="url"
          formControlName="link_formato"
          class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Ingrese un link válido"
        />
        <div
          *ngIf="
            documentoForm.get('link_formato')?.invalid &&
            documentoForm.get('link_formato')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          El enlace es obligatorio y debe ser válido.
        </div>
      </div>
    </div>

    <!-- Fechas (Inicio y Fin) en dos columnas -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Fecha de Inicio -->
      <div class="form-group">
        <label for="fecha_inicio" class="block text-lg font-medium"
          >Fecha de Inicio</label
        >
        <input
          id="fecha_inicio"
          type="date"
          [min]="hoy"
          formControlName="fecha_inicio"
          class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <div
          *ngIf="
            documentoForm.get('fecha_inicio')?.invalid &&
            documentoForm.get('fecha_inicio')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          La fecha de inicio es obligatoria.
        </div>
      </div>

      <!-- Fecha de Fin -->
      <div class="form-group">
        <label for="fecha_fin" class="block text-lg font-medium"
          >Fecha de Fin</label
        >
        <input
          id="fecha_fin"
          type="date"
          [min]="hoy"
          formControlName="fecha_fin"
          class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <div
          *ngIf="
            documentoForm.get('fecha_fin')?.invalid &&
            documentoForm.get('fecha_fin')?.touched
          "
          class="text-red-500 text-sm mt-1"
        >
          La fecha de fin es obligatoria.
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end items-center mt-6">
      <div>
        <button
          type="submit"
          class="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600"
        >
          Actualizar
        </button>
      </div>
    </div>
  </form>
</div>
